import ODS_LIST from '../../mocks/OdsArea/ods.json';

export const UseOdsArea = (area, odsNumber) => { // area: string, ods: number
  const response = { ods: [], areas: [] };

  response.areas = [...new Set([...ODS_LIST.areas])] 

  if(area) {
    const areaListIndex = ODS_LIST.areas.map((row, index) => (
      row == area ? { index, value: row } : null
    )).filter(row => row !== null);

    const newOdsList = [...new Set(
      areaListIndex.map(newArea => (
        newArea?.index ? ODS_LIST.ods[newArea?.index].split(' | ') : null  
      )).filter(row => row !== null)
    )] || [];

    newOdsList.map( odsList => {
      response.ods.push(...odsList)

      return odsList
    })

    response.ods = [...new Set(response.ods)]; 
  }

  return response;
}

